/*
 * Ryan O'Dowd
 * 2024-05-13
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Icon from '@react-native-vector-icons/material-design-icons';
import React from 'react';
import Surface from '@components/common/Surface';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const Banner = (props: BannerProps) => {
  const styles = hooks.useStyles(getStyles);
  let iconName: any = 'information';
  let color = styles.colors.primaryDark;
  let backgroundColor = styles.colors.primaryExtraLight;
  if (props.type === 'success') {
    iconName = 'check-decagram';
    color = styles.colors.accentDark;
    backgroundColor = styles.colors.accentLight;
  } else if (props.type === 'warning') {
    iconName = 'alert';
    color = styles.colors.warnIncorrect;
    backgroundColor = styles.colors.warningBg;
  } else if (props.type === 'error') {
    iconName = 'cancel';
    color = styles.colors.alertDark;
    backgroundColor = styles.colors.alertLight;
  }

  return (
    <Surface style={[styles.container, {backgroundColor}]}>
      <View style={styles.contentWrapper}>
        <Icon name={iconName} style={styles.icon} color={color} />
        <Text style={[styles.bannerText, {color}]}>{props.text}</Text>
        {props.leftButton}
      </View>
    </Surface>
  );
};

class BannerProps {
  text: string;
  type: 'success' | 'info' | 'warning' | 'error';

  leftButton?: React.ReactNode;
};

export default Banner;
